import { Link } from "@tanstack/react-router";
import { Fragment, type ReactNode } from "react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

export interface BreadcrumbTrailItem {
  /** Stable key for React. */
  key: string;
  /** A pre-built `<Link>` (or other element) that renders the crumb's label
   *  and navigation. Wrapped in `<BreadcrumbItem>` + `<BreadcrumbLink asChild>`
   *  automatically. */
  link: ReactNode;
}

interface PageBreadcrumbsProps {
  /** Trail items between Home and the current page. Empty if Home is the
   *  only parent. */
  trail?: BreadcrumbTrailItem[];
  /** The current page label (no link). Always the rightmost crumb. */
  current: ReactNode;
}

export function PageBreadcrumbs({ trail, current }: PageBreadcrumbsProps) {
  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to="/home">Home</Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        {trail?.map((item) => (
          <Fragment key={item.key}>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink asChild>{item.link}</BreadcrumbLink>
            </BreadcrumbItem>
          </Fragment>
        ))}
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          <BreadcrumbPage>{current}</BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  );
}
